
<template>
  <div>
    <DxSelectBox
      :search-enabled="true"
      :data-source="gridDataSource"
      :search-mode="searchModeOption"
      :search-expr="searchExprOption"
      :search-timeout="searchTimeoutOption"
      :min-search-length="minSearchLengthOption"
      :show-data-before-search="showDataBeforeSearchOption"
      :disabled="disabled"
       display-expr="name"
       value-expr="id"
      v-model="selectedItem"
      @value-changed="onValueChanged"
    />
  </div>
</template>
<script>
import { DxSelectBox } from "devextreme-vue/select-box";
import CustomStore from "devextreme/data/custom_store";

import axios from "axios";

export default {
  props: {
    rRoute: String,
    slug: String,
    rltName: String,
    currentModuleId:String,
    trname:String,
    disabled:Boolean,
   
    modelValue: {
      type: String,
      default: "",
      required: true,
    },
  },
  components: {
    DxSelectBox,
  },
  data() {
    return {
      gridDataSource: null,
      gridBoxValue: [this.modelValue],
      searchModeOption: "contains",
      searchExprOption: "name",
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      selectedItem :null,
      showDataBeforeSearchOption: false,
    };
  },

  created() {},
  methods: {
    makeAsyncDataSource(rRoute, slug,currentModuleId,) {
      return new CustomStore({
        loadMode: "raw",
        key: "id",
        load: function (loadOptions) {
         // let url = "/" + slug + "/" + rRoute + "/list";
        let url = "/trn/filterlist";

          var parameters = {
           currentModuleId:currentModuleId,
          };
          var mFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(mFilter);
          }

          var config = {
            params: parameters,
          };

          return axios
            .get(url, config)
            .then((response) => {
              console.log("Transaction Filter Response ",response);
              return response.data.results.data;
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
      });
    },

    onValueChanged(e) {
      console.log(" trn ON VALUE CHAGE",e.value);
      var obj = {
        relate_id: e.value,
        rltName: this.rltName,
        route: this.rRoute,
      };
      this.$emit("update:modelValue", e.value);
      this.$emit("transaction_selection", obj);
    },

    
  },

  mounted() {
    this.gridDataSource = this.makeAsyncDataSource(this.rRoute, this.slug,this.currentModuleId);
    this.selectedItem = this.modelValue
   
    // this.$refs.selectBox.instance.setValue(this.modelValue);
      // console.log(" TRANSACTION viewType",this.viewType)

  },
};
</script>
<style scoped>
</style>